// ============================================================
// PLUMME 2.0 — report, payroll and asset runtime contracts
// ============================================================
// Faktiske verdier publiseres av backend etter at aktivt foretak er lastet.
// Disse standardene er tomme og kan derfor aldri introdusere eksempeldata.
const TRIAL_BALANCE=[];
const RESULT={inntekter:0,kostnader:0,finans:0,resultat:0,sections:[]};
const EMPLOYEES=[];

const SKATTEREGLER=['Vanlige','Svalbard','Jan Mayen og bilandene','Særskilt fradrag for sjøfolk',
  'Veldedig eller allmennyttig organisasjon','Nettolønn','Nettolønn for sjøfolk','Kildeskatt på pensjoner',
  'Dagmamma i barnets hjem','Lønnsarbeid i hjemmet','Skattefri organisasjon'];

const MILEAGE_RATE=3.5;
const MILEAGE=[];
const PAY_OVERVIEW=[];
const PAY_TERMS=[];
const PAY_HOLIDAY=[];
const PAY_PENSION=[];
const PAY_RUNS=[];

// Dette er domenedefinisjoner, ikke virksomhets- eller eksempeldata.
const PAY_TYPES=[
  {name:'Fastlønn',kind:'Lønnstype',aga:true,tax:true,holiday:true,pension:true,active:true},
  {name:'Timelønn – ikke overtid',kind:'Lønnstype',aga:true,tax:true,holiday:true,pension:true,active:true},
  {name:'Timelønn – overtid',kind:'Lønnstype',aga:true,tax:true,holiday:true,pension:true,active:true},
  {name:'Honorar, akkord, prosent eller provisjon',kind:'Lønnstype',aga:true,tax:true,holiday:true,pension:true,active:true},
  {name:'Bonus, feriepengeopptjenende',kind:'Lønnstype',aga:true,tax:true,holiday:true,pension:true,active:true},
  {name:'Bonus, ikke feriepengeopptjenende',kind:'Lønnstype',aga:true,tax:true,holiday:false,pension:false,active:false},
  {name:'Styrehonorar',kind:'Lønnstype',aga:true,tax:true,holiday:false,pension:false,active:true},
  {name:'Fri bil',kind:'Naturalytelse',aga:true,tax:true,holiday:false,pension:false,active:true},
  {name:'Kantinetrekk',kind:'Trekk',aga:false,tax:false,holiday:false,pension:false,active:true},
];
const PAY_SETTINGS={pensionProvider:'',pensionOrg:'',agaSone:'',holidayRate:'',salaryAccount:'',taxAccount:'',reportingFreq:'',otpRate:''};
const ASSET_GROUPS={
  a:{label:'Gruppe a — Kontormaskiner og datautstyr',rate:30},
  c:{label:'Gruppe c — Varebiler og lastebiler',rate:24},
  d:{label:'Gruppe d — Maskiner og inventar',rate:20},
};
const EIENDELER=[];

Object.assign(window,{TRIAL_BALANCE,RESULT,EMPLOYEES,SKATTEREGLER,MILEAGE,MILEAGE_RATE,
  PAY_OVERVIEW,PAY_TERMS,PAY_HOLIDAY,PAY_PENSION,PAY_RUNS,PAY_TYPES,PAY_SETTINGS,ASSET_GROUPS,EIENDELER});
